import React from 'react';
import {
  ChartTooltip as FDChartTooltip,
  ChartTooltipInfoSection as FDChartTooltipInfoSection,
  ChartTooltipInfoSectionRow as FDChartTooltipInfoSectionRow,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const ChartTooltip = ({
  seriesDataPoints,
  rangeDataPointSets,
}) => {
  let title;
  if (seriesDataPoints && seriesDataPoints.length > 0) {
    title = seriesDataPoints[0]?.dataPoint?.formattedX();
  }

  const outcomes = seriesDataPoints
    .filter(({ dataPoint }) => dataPoint.meta().hasOutcomes)
    .flatMap(({ dataPoint }) => dataPoint.meta().outcomes);
  const clientDataPoint = seriesDataPoints.find(({ dataPoint }) => dataPoint.meta().clients.length > 0);
  const clients = clientDataPoint?.dataPoint.meta().clients;

  return (
    <FDChartTooltip
      title={title}
      subtitle={(clients?.length > 0) ? (clients.map((client) => {
        return `${client.attributes.shortName} (${client.attributes.ageForYear})`;
      }).join(' ')) : undefined}
      seriesDataPoints={seriesDataPoints}
      rangeDataPointSets={rangeDataPointSets}
    >
      {outcomes?.length > 0 ? (
        <FDChartTooltipInfoSection
          title={'Outcomes'}
        >
          {outcomes.map((outcome) => {
            return (
              <FDChartTooltipInfoSectionRow
                key={outcome.id}
                label={outcome.attributes.title}
              />
            );
          })}
        </FDChartTooltipInfoSection>
      ) : undefined}
    </FDChartTooltip>
  );
};

ChartTooltip.defaultProps = {
  seriesDataPoints: [],
  rangeDataPointSets: [],
};

ChartTooltip.propTypes = {
  seriesDataPoints: PropTypes.array,
  rangeDataPointSets: PropTypes.array,
};

export default ChartTooltip;
